"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseNumber = parseNumber;
function parseNumber(rawValue) {
  return Number.parseInt(rawValue, 10);
}
